export default {
  BT_HDP: "ហាន់ឌីកែប | HDP",
  BT_OU: "លើ/ក្រោម | O/U",
  BT_ML: "ប្រាក់ស្មើ",
  BT_1X2: "1X2",
  BT_1X2HDP: "3 វិធីហាន់ឌីកែប",
  BT_CS: "លទ្ធផលត្រឹមត្រូវ",
  BT_OE: "សេស/គូ | O/E",
  BT_DC: "ឱកាសទ្វេដង",
  BT_HTFT: "ពាក់កណ្តាលពេល/ពេលពេញ",
  BT_FGLG: "គ្រាប់បាល់ដំបូង/ចុងក្រោយ",
  BT_TG: "ចំនួនគ្រាប់បាល់សរុប",
  BT_OR: "ឈ្នះជើងឯក",
  BT_ORZ: "ឈ្នះជើងឯក",

  BT_ANB: "ក្រុមអន្តោប្រវេសន៍ មិនមានភ្នាល់",
  BT_BS: "ទាំងពីរ/មួយ/គ្មានក្រុមស៊ុតបាន",
  BT_CL: "រក្សាបរិសុទ្ធ",
  BT_DNB: "ស្មើមិនមានភ្នាល់",
  BT_HNB: "ក្រុមផ្ទះ មិនមានភ្នាល់",
  BT_TWTN: "ឈ្នះដោយគ្មានទទួលបាល់",

  BT_HDPF: "ពេលពេញ. ហាន់ឌីកែប | FT. HDP",
  BT_OUF: "ពេលពេញ. លើ/ក្រោម | FT. O/U",
  BT_MLF: "ពេលពេញ. ប្រាក់ស្មើ",
  BT_1X2F: "ពេលពេញ. 1X2",
  BT_1X2HDPF: "ពេលពេញ. 3 វិធីហាន់ឌីកែប",
  BT_CSF: "ពេលពេញ. លទ្ធផលត្រឹមត្រូវ",
  BT_OEF: "ពេលពេញ. សេស/គូ",
  BT_DCF: "ពេលពេញ. ឱកាសទ្វេដង",
  BT_FGLGF: "ពេលពេញ. គ្រាប់ដំបូង/ចុងក្រោយ",
  BT_TGF: "ពេលពេញ. ចំនួនគ្រាប់សរុប",

  BT_HDPH: "1H. ហាន់ឌីកែប | 1H. HDP",
  BT_OUH: "1H. លើ/ក្រោម | 1H. O/U",
  BT_MLH: "1H. ប្រាក់ស្មើ",
  BT_1X2H: "1H. 1X2",
  BT_1X2HDPH: "1H. 3 វិធីហាន់ឌីកែប",
  BT_CSH: "1H. លទ្ធផលត្រឹមត្រូវ",
  BT_OEH: "1H. សេស/គូ",
  BT_DCH: "1H. ឱកាសទ្វេដង",
  BT_FGLGH: "1H. គ្រាប់ដំបូង/ចុងក្រោយ",
  BT_TGH: "1H. ចំនួនគ្រាប់សរុប",

  BT_HDPOU: "ហាន់ឌីកែប & លើ/ក្រោម",
  BT_PARLAY: "ភ្នាល់ចម្រុះ",
  BT_FT: "ពេលពេញ. ",
  BT_1H: "1H. ",
  BT_2H: "2H. ",

  BT_FG: "គ្រាប់ដំបូង",
  BT_LG: "គ្រាប់ចុងក្រោយ",
  BT_HFG: "គ្រាប់ដំបូង (ផ្ទះ)",
  BT_AFG: "គ្រាប់ដំបូង (អន្តោប្រវេសន៍)",
  BT_HLG: "គ្រាប់ចុងក្រោយ (ផ្ទះ)",
  BT_ALG: "គ្រាប់ចុងក្រោយ (អន្តោប្រវេសន៍)",
  BT_NG: "គ្មានគ្រាប់បាល់",
  BT_HY: "ផ្ទះ បាទ/ចាស",
  BT_HN: "ផ្ទះ ទេ",
  BT_AY: "អន្តោប្រវេសន៍ បាទ/ចាស",
  BT_AN: "អន្តោប្រវេសន៍ ទេ",
  BT_H: "ផ្ទះ",
  BT_A: "អន្តោប្រវេសន៍",
  BT_D: "ស្មើ",
  BT_HD_DC: "HD (ផ្ទះ/ស្មើ)",
  BT_HA_DC: "HA (ផ្ទះ/អន្តោប្រវេសន៍)",
  BT_DA_DC: "DA (ស្មើ/អន្តោប្រវេសន៍)",
  BT_HH: "ផ្ទះ/ផ្ទះ",
  BT_HD: "ផ្ទះ/ស្មើ",
  BT_HA: "ផ្ទះ/អន្តោប្រវេសន៍",
  BT_DH: "ស្មើ/ផ្ទះ",
  BT_DD: "ស្មើ/ស្មើ",
  BT_DA: "ស្មើ/អន្តោប្រវេសន៍",
  BT_AH: "អន្តោប្រវេសន៍/ផ្ទះ",
  BT_AD: "អន្តោប្រវេសន៍/ស្មើ",
  BT_AA: "អន្តោប្រវេសន៍/អន្តោប្រវេសន៍",

  BT_Y: "បាទ/ចាស",
  BT_N: "ទេ",

  BT_LIVE: "បន្តផ្ទាល់",
  BT_HT: "ពាក់កណ្តាលពេល",
  BT_DELAYED: "ពន្យាពេល",
  BT_PEN: "បាល់ប៉េនាល់ធី",

  BT_FT1: "ពេលពេញ.1",
  BT_FT2: "ពេលពេញ.2",
  BT_FTX: "ពេលពេញ.X",
  BT_HT1: "ពាក់កណ្តាល.1",
  BT_HT2: "ពាក់កណ្តាល.2",
  BT_HTX: "ពាក់កណ្តាល.X",

  BT_BOTH: "ទាំងពីរ",
  BT_ONE: "មួយ",

  LOT_BS: "ធំ/តូច",
  LOT_BIG: "ធំ",
  LOT_SMALL: "តូច",
  LOT_OE: "សេស/គូ",
  LOT_ODD: "សេស",
  LOT_EVEN: "គូ",
  LOT_OU: "លើ/ក្រោម",
  LOT_OVER: "លើ",
  LOT_UNDER: "ក្រោម",

  BT_ALL: "@:ui.bet_list",

  D_1: "លេខតែមួយ",
  D_2: "លេខ និងត្រឡប់",
  D_3: "ប្រអប់",
  D_4: "iBox",
  D_5: "3 ខ្ទង់ចុងក្រោយ",
  D_6: "2 ខ្ទង់ចុងក្រោយ",

  D_BIG: "ធំ",
  D_SMALL: "តូច",
  D_AA: "AA",
  D_SA: "3A",
  D_SB: "B",
  D_SC: "C",
  D_SD: "D",
  D_SE: "E",
  D_ABC: "3C",

  BT_HDPMMO: "HDP MMO",
  BT_OUMMO: "OU MMO",

  BT_OEHM: "លទ្ធផលសេស/គូ (ផ្ទះ)",
  BT_OEHMH: "ពាក់កណ្តាល 1: សេស/គូ (ផ្ទះ)",
  BT_OEAW: "លទ្ធផលសេស/គូ (អន្តោប្រវេសន៍)",
  BT_OEAWH: "ពាក់កណ្តាល 1: សេស/គូ (អន្តោប្រវេសន៍)",

  BS_OEHM: "ពេលពេញ: សេស/គូ (ផ្ទះ)",
  BS_OEHMH: "ពាក់កណ្តាល 1: សេស/គូ (ផ្ទះ)",
  BS_OEAW: "ពេលពេញ: សេស/គូ (អន្តោប្រវេសន៍)",
  BS_OEAWH: "ពាក់កណ្តាល 1: សេស/គូ (អន្តោប្រវេសន៍)",

  MB_OVER: "លើ (4,5,6)",
  MB_UNDER: "ក្រោម (1,2,3)",
  MB_ODD: "សេស (1,3,5)",
  MB_EVEN: "គូ (2,4,6)",

  BS_1X2OU: "1X2 + លើ/ក្រោម",
  BT_1X2OU: "1X2 + លើ/ក្រោម",
  BT_1O: "1 លើ",
  BT_1U: "1 ក្រោម",
  BT_2O: "2 លើ",
  BT_2U: "2 ក្រោម",
  BT_XO: "X លើ",
  BT_XU: "X ក្រោម",

  BS_DCOU: "Double Chance + លើ/ក្រោម",
  BT_DCOU: "Double Chance + លើ/ក្រោម",
  BT_HDO: "HDO",
  BT_HDU: "HDU",
  BT_HAO: "HAO",
  BT_HAU: "HAU",
  BT_DAO: "DAO",
  BT_DAU: "DAU",

  BS_OUOE: "លើ/ក្រោម + សេស/គូ",
  BT_OUOE: "លើ/ក្រោម + សេស/គូ",
  BK_OO: "លើ-លើ",
  BK_OE: "លើ-គូ",
  BK_UO: "ក្រោម-លើ",
  BK_UE: "ក្រោម-គូ",

  BS_HTFTOE: "ពាក់កណ្តាល/ពេលពេញ + សេស/គូ",
  BT_HTFTOE: "ពាក់កណ្តាល/ពេលពេញ + សេស/គូ",
  BK_EO: "គូ-សេស",
  BK_EE: "គូ-គូ",

  BS_WM: "ចំណេញដោយលទ្ធផល",
  BT_WM: "ចំណេញដោយលទ្ធផល",
  BK_H1: "ផ្ទះ 1",
  BK_H2: "ផ្ទះ 2",
  BK_H3Up: "ផ្ទះ 3+",
  BK_A1: "អន្តោប្រវេសន៍ 1",
  BK_A2: "អន្តោប្រវេសន៍ 2",
  BK_A3Up: "អន្តោប្រវេសន៍ 3+",
  BK_D: "ស្មើ (មិនរាប់ 0-0)",
  BK_NG: "គ្មានគ្រាប់បាល់",

  BS_ETG: "ចំនួនគ្រាប់បាល់ត្រឹមត្រូវ",
  BT_ETG: "ចំនួនគ្រាប់បាល់ត្រឹមត្រូវ",
  BS_EHTG: "ចំនួនគ្រាប់បាល់ផ្ទះត្រឹមត្រូវ",
  BT_EHTG: "ចំនួនគ្រាប់បាល់ផ្ទះត្រឹមត្រូវ",
  BS_EATG: "ចំនួនគ្រាប់បាល់អន្តោប្រវេសន៍ត្រឹមត្រូវ",
  BT_EATG: "ចំនួនគ្រាប់បាល់អន្តោប្រវេសន៍ត្រឹមត្រូវ",
  BS_ETGH: "ពាក់កណ្តាល 1: ចំនួនគ្រាប់បាល់ត្រឹមត្រូវ",
  BT_ETGH: "ពាក់កណ្តាល 1: ចំនួនគ្រាប់បាល់ត្រឹមត្រូវ",
  BS_EHTGH: "ពាក់កណ្តាល 1: គ្រាប់បាល់ផ្ទះត្រឹមត្រូវ",
  BT_EHTGH: "ពាក់កណ្តាល 1: គ្រាប់បាល់ផ្ទះត្រឹមត្រូវ",
  BS_EATGH: "ពាក់កណ្តាល 1: គ្រាប់បាល់អន្តោប្រវេសន៍ត្រឹមត្រូវ",
  BT_EATGH: "ពាក់កណ្តាល 1: គ្រាប់បាល់អន្តោប្រវេសន៍ត្រឹមត្រូវ",
  BT_0: "0",
  BT_1: "1",
  BT_2: "2",
  BT_3: "3",
  BT_4: "4",
  BT_5: "5",
  BT_6Up: "6+",
  BT_3Up: "3+",

  BT_CSHTFT: "ពាក់កណ្តាល/ពេលពេញ លទ្ធផលត្រឹមត្រូវ",
  BS_CSHTFT: "ពាក់កណ្តាល/ពេលពេញ លទ្ធផលត្រឹមត្រូវ",
  BT_ETGHTFT: "ពាក់កណ្តាល/ពេលពេញ ចំនួនគ្រាប់បាល់ត្រឹមត្រូវ",
  BS_ETGHTFT: "ពាក់កណ្តាល/ពេលពេញ ចំនួនគ្រាប់បាល់ត្រឹមត្រូវ",

  MBR_SINGLE: "Single",
  MBR_TRIPS: "Trips",
  MBR_PAIR: "Pair",
};